<template>
	<div class="m-search">
		<div class="m-search-hadnle flex-center-cross">
			<c-button @click="search">查询</c-button>
			<c-button color="black" hollow @click="clear">重置条件</c-button>
		</div>
		<div class="m-search-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',
		
		mounted() {
			this.$form = this.$children.find(item => item.$options.name == 'cForm');
		},

		methods: {
			search(page = 1) {
				var data = this.$form.serialize();
				this.$emit('search', data, page);
			},
			
			get() {
				return this.$form.serialize();
			},
			
			clear() {
				this.$form.clear();
			}
		}
	}
</script>

<style lang="stylus">
	@import './style/search'
</style>
